import type { Occurrence } from "../../interface/occurrences"
import type { UUID } from "../../interface/publications"
import { businessApi, postBotTags } from "./api"

export const occurrencesApi = businessApi.injectEndpoints({
  endpoints: (build) => ({
    getOccurrence: build.query<Occurrence, UUID>({
      query: (id) => `occurrences/${id}`,
      providesTags: (_result, _error, id) => [postBotTags.occurrence(id)],
    }),
  }),
})

export const { useGetOccurrenceQuery, useLazyGetOccurrenceQuery } =
  occurrencesApi
